import { TweenMax } from 'gsap';
import { SplitText } from '@/scripts/libs/SplitText';

const TheOThersInitial = (element) => {
  const title = element.querySelector('.the-others__title');
  const text = element.querySelector('.the-others__text');

  const split = new SplitText(title, { charsClass: 'the-others__title-char' });
  TweenMax.set(split.chars, { y: 80, autoAlpha: 0 });
  TweenMax.set(text, { y: 100, autoAlpha: 0 });
};

export default TheOThersInitial;
